module.exports = "/logo-no-text-52eaf29c18f146fcd25246a2ab2faaac.svg";